<div class="documents-list" *transloco="let t">
  <mat-table [dataSource]="dataSource" matSort matSortDisableClear>
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <xt-ui-kit-checkbox
          [indeterminate]="
            data.length !== (selectedData && selectedData.length) &&
            (selectedData && selectedData.length) > 0
          "
          [dataCy]="dataCy + 'head-checkbox'"
          [checked]="data.length === (selectedData && selectedData.length)"
          [ariaLabel]="t('app.labels.all')"
          (onKeyDown)="selectAll()"
          (click)="selectAll()"
          />
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <xt-ui-kit-checkbox
            [dataCy]="dataCy + 'cell-checkbox' + row.id"
            [disabled]="lockData"
            [ariaLabel]="t('app.labels.selectItem')"
            (onKeyDown)="toggleItem(row.id)"
            [checked]="check(row.id)"
            (click)="toggleItem(row.id)"
            />
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [xTentionDummyCypress]="dataCy + 'cell-type'"
            >
            {{ t('app.documents.table.type') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            [xTentionDummyCypress]="dataCy + 'cell-type.' + row.id"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            >
            <div class="type-icon">
              @switch (row.type) {
                @case ('document') {
                  <mat-icon
                    svgIcon="file-document-outline"
                  ></mat-icon>
                }
                @case ('video') {
                  <mat-icon svgIcon="movie-outline"></mat-icon>
                }
                @case ('image') {
                  <mat-icon
                    svgIcon="image-multiple-outline"
                  ></mat-icon>
                }
                @default {
                  <mat-icon svgIcon="file-document-outline"></mat-icon>
                }
              }
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [xTentionDummyCypress]="dataCy + 'cell-name'"
            >
            {{ t('app.documents.table.name') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            class="name"
            [xTentionDummyCypress]="dataCy + 'cell-name.' + row.id"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            >
            <span class="bold">
              {{ row.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [attr.data-cy]="dataCy + 'cell-id'"
            >
            {{ t('app.documents.table.id') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            class="name"
            [attr.data-cy]="dataCy + 'cell-id.' + row.id"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            >
            <span class="bold idText">
              {{ row.id }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="userIdentifier">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [attr.data-cy]="dataCy + 'cell-userIdentifier'"
            >
            {{ t('app.documents.table.id') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            (click)="onRowClick(row)"
            class="name"
            [attr.data-cy]="dataCy + 'cell-id.' + row.id"
            >
            <span class="bold idText">
              {{ row.userIdentifier }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [xTentionDummyCypress]="dataCy + 'cell-date'"
            >
            {{ t('app.documents.table.uploadedAt') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            [xTentionDummyCypress]="dataCy + 'cell-date.' + row.id"
            >
            <span>{{ row.date | date: 'dd.MM.yyyy - HH:mm' }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="releasedBy">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [xTentionDummyCypress]="dataCy + 'cell-released-by'"
            >
            {{ t('app.documents.table.releasedAt') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            [xTentionDummyCypress]="dataCy + 'cell-released-by.' + row.id"
            >
            <span>{{ row.releasedBy }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="releasedOn">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [xTentionDummyCypress]="dataCy + 'cell-released-on'"
            >
            {{ t('app.documents.table.releasedOn') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            [xTentionDummyCypress]="dataCy + 'cell-released-on.' + row.id"
            ><span>{{ row.releasedOn | date: 'dd.MM.yyyy - HH:mm' }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell
            *matHeaderCellDef
            [xTentionDummyCypress]="dataCy + 'cell-status'"
            >
            {{ t('app.documents.questionnaires.status') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            class="classification-wrapper"
            [xTentionDummyCypress]="dataCy + 'cell-status.' + row.id"
            >
            <xt-portal-tags
              class="tag"
              [color]="questionnairesService.getStatusColor(row.status)"
              [text]="questionnairesService.getStatusTranslations(row.status)"
            ></xt-portal-tags>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="reconciliationStatus">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [xTentionDummyCypress]="dataCy + 'cell-status'"
            >
            {{ t('app.documents.questionnaires.status') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            class="classification-wrapper"
            [xTentionDummyCypress]="dataCy + 'cell-status.' + row.id"
            >
            <xt-portal-tags
              class="tag"
          [color]="
            reconciliationService.getStatusColor(row.reconciliationStatus)
          "
          [text]="
            reconciliationService.getStatusTranslations(
              row.reconciliationStatus
            )
          "
            ></xt-portal-tags>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="size">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [xTentionDummyCypress]="dataCy + 'cell-size'"
            >
            {{ t('app.documents.table.size') }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            [attr.aria-label]="row.name"
            (click)="onRowClick(row)"
            [xTentionDummyCypress]="dataCy + 'cell-size.' + row.id"
            >
            <span>{{ row.size | byte }}</span></mat-cell
            >
          </ng-container>

          <ng-container matColumnDef="tags">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [xTentionDummyCypress]="dataCy + 'cell-tags'"
              >
              {{ t('app.documents.table.classification') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="classification-wrapper"
              [xTentionDummyCypress]="dataCy + 'cell-tags.' + row.id"
              >
              @if (getAllTagsByRow(row).length === 1) {
                <xt-portal-tags
                  class="tag"
                  [text]="getAllTagsByRow(row)[0]"
                ></xt-portal-tags>
              }

              @if (getAllTagsByRow(row).length > 1) {
                <div
                  class="multiple-categories"
                  >
                  <xt-portal-tags
                    class="tag"
                    text="Mehrere..."
                    matTooltipClass="categories-tooltip"
                    [matTooltip]="getAllTagsByRow(row).join(', ')"
                  ></xt-portal-tags>
                </div>
              }
            </mat-cell>
          </ng-container>

          <!--Privacy cockpit providers list columns-->

          <ng-container matColumnDef="facilityType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ t('app.labels.facilityType') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="facility"
              >
              <span>
                {{ row.facilityType }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="facility">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ t('app.labels.organisation') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="facility"
              >
              <span>
                {{ row.facility }}
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="transferTo">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ t('app.labels.transferTo') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="facility"
              >
              <span>
                {{ row.transferTo }}
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="transferTrough">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ t('app.labels.transferTrough') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="facility"
              >
              <span>
                {{ row.transferTrough }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="subjectArea">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ t('app.labels.subjectArea') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="subjectArea"
              >
              <span>
                {{ row.subjectArea }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="specialty">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [xTentionDummyCypress]="dataCy + 'cell-specialty'"
              >
              {{ t('app.labels.subjectArea') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="subjectArea"
              [xTentionDummyCypress]="dataCy + 'cell-subject-area.' + row.id"
              >
              <span>
                {{ row.specialty }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="organizationName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ t('app.labels.facility') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="subjectArea"
              >
              <span>
                {{ row.organizationName }}
              </span>
            </mat-cell>
          </ng-container>

          <!--Patient list columns-->
          <ng-container matColumnDef="lastName">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [xTentionDummyCypress]="dataCy + 'cell-last-name'"
              >
              {{ t('app.labels.lastName') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="lastName"
              [xTentionDummyCypress]="dataCy + 'cell-last-name.' + row.id"
              >
              <span class="bold">
                {{ row.lastName }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="firstName">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [xTentionDummyCypress]="dataCy + 'cell-first-name'"
              >
              {{ t('app.labels.firstName') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              class="firstName"
              [xTentionDummyCypress]="dataCy + 'cell-first-name.' + row.id"
              >
              <span>
                {{ row.firstName }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="birthdate">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [xTentionDummyCypress]="dataCy + 'cell-birthdate'"
              >
              {{ t('app.labels.birthday') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-birthdate.' + row.id"
              class="birthdate"
              >
              <span>
                {{ row.birthdate | date: 'dd.MM.yyyy' }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="gender">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [xTentionDummyCypress]="dataCy + 'cell-gender'"
              >
              {{ t('app.labels.gender') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-gender.' + row.id"
              class="gender"
              >
              <span>
                {{ getPersonGender(row) }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="address">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [xTentionDummyCypress]="dataCy + 'cell-address'"
              >
              {{ t('app.labels.address') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-address.' + row.id"
              class="address"
              >
              <span>
                {{ row.address }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="roleIcon">
            <mat-header-cell
              *matHeaderCellDef
              [xTentionDummyCypress]="dataCy + 'cell-roleIcon'"
              >
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-roleIcon.' + row.id"
              class="roleIcon"
              >
              <mat-icon svgIcon="account-group-outline"></mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="role">
            <mat-header-cell
              *matHeaderCellDef
              [xTentionDummyCypress]="dataCy + 'cell-defaultAction'"
              >
              {{ t('app.inactiveAccounts.role') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-role.' + row.id"
              class="role"
              >
              <span>
                {{ row.role }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="accountId">
            <mat-header-cell
              *matHeaderCellDef
              [xTentionDummyCypress]="dataCy + 'cell-accountId'"
              >
              {{ t('app.inactiveAccounts.accountId') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-accountId.' + row.id"
              class="accountId"
              >
              <span>
                {{ row.accountId }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastLogin">
            <mat-header-cell
              *matHeaderCellDef
              [xTentionDummyCypress]="dataCy + 'cell-defaultAction'"
              >
              {{ t('app.inactiveAccounts.lastLogin') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-lastLogin.' + row.id"
              class="lastLogin"
              >
              <span>
                {{ row.lastLogin }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="defaultAction">
            <mat-header-cell
              *matHeaderCellDef
              [xTentionDummyCypress]="dataCy + 'cell-defaultAction'"
              >
              {{ t('app.labels.defaultAction') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-defaultAction.' + row.id"
              class="defaultAction"
              >
              <span>
                {{ row.name }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="logo">
            <mat-header-cell
              *matHeaderCellDef
              [xTentionDummyCypress]="dataCy + 'cell-defaultAction'"
              >
              {{ t('app.labels.system') }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-defaultAction.' + row.id"
              class="defaultAction"
              >
              <img [src]="row.logo" alt="System Logo" />
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="show">
            <mat-header-cell
              *matHeaderCellDef
              [xTentionDummyCypress]="dataCy + 'cell-show'"
              >
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [attr.aria-label]="row.name"
              (click)="onRowClick(row)"
              [xTentionDummyCypress]="dataCy + 'cell-show.' + row.id"
              class="show"
              >
              <xt-portal-button
                [xTentionDummyCypress]="'cell-show. ' + row.id"
                (clickEvent)="openLink(row.url)"
                [text]="t('app.labels.show')"
                color="none"
                width="small"
              ></xt-portal-button>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="settings">
            <mat-header-cell
              *matHeaderCellDef
              [xTentionDummyCypress]="dataCy + 'cell-settings'"
              >
            </mat-header-cell>

            <mat-cell *matCellDef="let row">
              <xt-ui-kit-dropdown-button
                [dataCy]="'cell-settings.' + row.id"
                icon="more_vert"
                color="none"
                width="normal"
                [style]="'flat'"
                [ariaLabel]="t('app.labels.moreOptions')"
                [isDropdown]="isDropdownIcon"
                [updateDropdownItems]="updateDropdownItems()"
                [dropdownItems]="getDropDownItemsFiltered(row) | hideFilter: row"
                (clickEvent)="onClickHandler({ methodName: $event, row: row })"
                />
              </mat-cell>
            </ng-container>

            <!--Logbook columns-->
            <ng-container matColumnDef="dateAndTime">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [xTentionDummyCypress]="dataCy + 'cell-date-and-time'"
                >
                {{ t('app.labels.dateAndTime') }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                [xTentionDummyCypress]="dataCy + 'cell-date-and-time.' + row.id"
                [attr.aria-label]="row.name"
                (click)="onRowClick(row)"
                class="dateAndTime"
                >
                <span>
                  {{ row.dateAndTime | date: 'dd.MM.yyyy - HH:mm' }}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="activity">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [xTentionDummyCypress]="dataCy + 'cell-activity'"
                >
                {{ t('app.labels.activity') }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                [attr.aria-label]="row.name"
                (click)="onRowClick(row)"
                [xTentionDummyCypress]="dataCy + 'cell-activity.' + row.id"
                class="activity"
                >
                @switch (row.activity) {
                  @case ('Dateien') {
                    <mat-icon
                      class="svg-icon"
                      svgIcon="folder-outline"
                    ></mat-icon>
                  }
                  @case ('Stammdaten') {
                    <mat-icon
                      class="svg-icon"
                      svgIcon="account-outline"
                    ></mat-icon>
                  }
                  @case ('Tagebuch') {
                    <mat-icon
                      class="svg-icon"
                      svgIcon="book-outline"
                    ></mat-icon>
                  }
                  @case ('Nachrichten') {
                    <mat-icon
                      class="svg-icon"
                      svgIcon="message-text"
                    ></mat-icon>
                  }
                  @case ('Wochenplan') {
                    <mat-icon
                      class="svg-icon"
                      svgIcon="calendar-check"
                    ></mat-icon>
                  }
                  @default {
                    <mat-icon
                      class="svg-icon"
                      svgIcon="book-outline"
                    ></mat-icon>
                  }
                }
                <span class="bold">
                  {{ row.activity }}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="details">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [xTentionDummyCypress]="dataCy + 'cell-details'"
                >
                {{ t('app.labels.details') }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                [attr.aria-label]="row.name"
                (click)="onRowClick(row)"
                [xTentionDummyCypress]="dataCy + 'cell-details.' + row.id"
                class="details"
                >
                <div class="description-wrapper">
                  <p>
                    {{ row.details }}
                  </p>
                  @if (row.further_infos) {
                    <p>{{ row?.further_infos }}</p>
                  }
                </div>
              </mat-cell>
            </ng-container>

            <!--Add Questionnaire columns-->
            <ng-container matColumnDef="version">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [xTentionDummyCypress]="dataCy + 'cell-version'"
                >
                Version
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                [attr.aria-label]="row.name"
                (click)="onRowClick(row)"
                [xTentionDummyCypress]="dataCy + 'cell-version.' + row.id"
                class="version"
                >
                <span>
                  {{ row?.version }}
                </span>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{
        'activated-element': selectedDataId === row.id && displaySelectedRow
      }"
            ></mat-row>
          </mat-table>
        </div>
